import React, { FunctionComponent, PropsWithChildren } from 'react';

import { default as MuiMenuItem, MenuItemProps } from '@mui/material/MenuItem';

const MenuItem: FunctionComponent<MenuItemProps> = (
  props: PropsWithChildren<MenuItemProps>
) => {
  return <MuiMenuItem {...props}>{props.children}</MuiMenuItem>;
};

export default MenuItem;
